import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Route } from 'react-router-dom';

export const PassthroughRoute = ({ path, exact, component: Component, makeProps = (p) => p }) => {
    const render = useCallback(
        ({ match }) => {
            const props = makeProps(match.params);

            return props && <Component {...props} />;
        },
        [Component, makeProps]
    );

    return <Route exact={exact} path={path} render={render} />;
};

PassthroughRoute.propTypes = {
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    exact: PropTypes.bool,
    component: PropTypes.any.isRequired,
    makeProps: PropTypes.func,
};
